<template>
    <div class="c-about-quarkino">
        <y-row>
            <y-col
                lg="5"
                md="12"
            >
                <div class="c-about-quarkino__title">
                    <h1>
                        {{ content.title }}
                    </h1>
                    <h2>
                        {{ content.title2 }}
                    </h2>
                </div>
            </y-col>
            <y-col
                lg="7"
                md="12"
                class="c-about-quarkino__content"
            >
                <p>
                    {{ content.synopsis }}
                </p>
            </y-col>

            <y-col
                v-if="content.image"
                lg="12"
                md="12"
                class="c-about-quarkino__image"
            >
                <img
                    :src="content.image.versions.main1 || content.image.link"
                    :alt="content.title"
                >
            </y-col>
        </y-row>
    </div>
</template>

<script>
    export default {
        name : 'AboutQuarkino',
        props: {
            content: Object,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
